import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, inject, input, InputSignal, output, signal, viewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormStepperService } from './services/form-stepper.service';
import { FormStep1Component, FormStep2Component, FormStep3Component, FormStep4Component, FormStep5Component, NavigationButtonsComponent } from "./components";
  
@Component({
  selector: 'app-register-user-form-mobile',
  standalone: true,
  imports: [
    TranslateModule,
    FormStep1Component,
    FormStep2Component,
    FormStep3Component,
    FormStep4Component,
    FormStep5Component,
    NavigationButtonsComponent
],
  templateUrl: './register-user-form-mobile.component.html',
  styleUrls: ['./register-user-form-mobile.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterUserFormMobileComponent {
  // ViewChilds
  private _swiperRef = viewChild<ElementRef>('swiper');
  
  // Inputs
  public form: InputSignal<FormGroup> = input.required<FormGroup>();
  
  // Outputs
  public submitFormEmitter = output<void>();
  
  // Services
  private _formStepperService = inject(FormStepperService);
  
  // State component signals
  private _domReady = signal(false);

  // Effects
  initSwiperEffect = effect(() => {
    if (!this._domReady() || !this._swiperRef()) return;
    
    const swiperElement = this._swiperRef()?.nativeElement;
    if (!swiperElement) return;
    
    this._formStepperService.initSwiper(swiperElement, {
      allowTouchMove: false,
      showPagination: true,
      loopMode: false
    });
  }, { allowSignalWrites: true } );

  formSubmissionEffect = effect(() => {
    if (this._formStepperService.shouldSubmitForm()) {
      this.submitFormEmitter.emit();
      this._formStepperService.resetFormSubmissionTrigger();
    }
  }, { allowSignalWrites: true });

  // Lifecycle hooks
  ngAfterViewInit(): void {
    this._domReady.set(true);
  }

  ngOnDestroy(): void {
    this._formStepperService.destroySwiper();
  }
}